import AppConfigurationService from '@services/app-configuration-service/app-configuration-service';
import { isSignInAndSecurityFeature } from '@services/authentication-service/utils/is-webview';
import { Buffer } from 'buffer';

export const getBase64ConsumerKey = () => {
    const appConfiguration =
        new AppConfigurationService().getAppConfiguration();
    const { brand, fmaRegion } = appConfiguration;
    const search =
        typeof globalThis.location === 'undefined'
            ? ''
            : globalThis.location.search;

    return Buffer.from(
        `ga-${fmaRegion}-${brand}${
            isSignInAndSecurityFeature(search) ? '-mobile' : ''
        }`
    ).toString('base64');
};
